import { MapPin, Clock, Users, Calendar } from "lucide-react";
import { authFetch } from "../../../api";
import { useEffect, useState } from "react";

export default function EventCard() {
  const [events, setEvents] = useState([]);

  const fetchEvents = async () => {
    try {
      const response = await authFetch("get-upcoming-events");
      setEvents(response.data.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchEvents();
  }, []);

  return (
    <div className="grid gap-6">
      {events.length === 0 && (
        <div className="flex justify-center font-inter">
          <div
            className="relative w-full  rounded-2xl border bg-white p-6 text-center shadow-sm"
            style={{
              background:
                "linear-gradient(153.85deg, #FFFFFF 58.41%, #FBF5FF 100.13%)",
            }}
          >
            {/* Glow background */}
            <div className="absolute inset-0 -z-10 rounded-3xl bg-purple-200/40 blur-3xl"></div>

            {/* Icon */}
            <div className="flex items-center justify-center">
              <img
                src="/NoEvents.png"
                alt="NoEvents"
                className="h-[154px] w-[124px] "
              />
            </div>

            {/* Title */}
            <h3 className="text-lg font-semibold text-gray-900">
              Your Upcoming Opportunities
            </h3>

            {/* Description */}
            <p className="mt-2 text-sm text-gray-500">
              Workshops, webinars, and opportunities tailored to your
              study-abroad journey.
            </p>
          </div>
        </div>
      )}

      {events.map((event, index) => (
        <div
          key={index}
          className="w-full max-w-[400px] sm:max-w-[450px] bg-white rounded-2xl border overflow-hidden shadow-lg hover:shadow-xl transition-shadow mx-auto"
        >
          {/* Image */}
          <div className="relative">
            <img
              src="/SAPImages/Dashboard/EventCard.png"
              alt={event.campaign_name}
              className="w-full h-40 sm:h-48 object-cover"
            />

            {/* Date Badge */}
            <div className="absolute top-3 right-3 bg-white text-red-700 px-3 py-1 rounded-md text-xs font-semibold flex items-center gap-1">
              <Calendar size={12} />
              <span>{new Date(event.campaign_start_date).toDateString()}</span>
            </div>
          </div>

          {/* Content */}
          <div className="p-4 space-y-4">
            <div className="text-sm font-semibold text-[#161719]">
              {event.campaign_name}
            </div>

            <div className="flex items-start gap-2">
              <MapPin size={18} className="text-[#572575]" />
              <p className="text-xs text-[#333333]">
                {event.address_of_event || "Online Event"}
              </p>
            </div>

            <div className="flex items-center gap-2">
              <Clock size={18} className="text-[#572575]" />
              <p className="text-xs font-medium text-[#333333]">
                {event.start_time && event.end_time
                  ? `${event.start_time} - ${event.end_time}`
                  : "Time will be announced"}
              </p>
            </div>

            <button className="w-full bg-[#572575] text-xs text-white font-semibold py-2 rounded-lg flex items-center justify-center gap-2">
              Register Now
              <Users size={16} />
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
